import React from 'react'

type ContextType = {
  map: google.maps.Map | null
  handleMapLoad: (map: google.maps.Map) => any
  search: any
  setSearch: (value: any) => {}
}

const MapContext = React.createContext<ContextType>({
  map: null,
  handleMapLoad: (map: google.maps.Map) => ({}),
  search: {},
  setSearch: (value: any) => ({}),
})

export function GoogleMapProvider(props: any) {
  const [map, setMap] = React.useState<google.maps.Map | null>(null)
  const [search, setSearch] = React.useState<any>({})

  const handleMapLoad = React.useCallback((mapInstance: google.maps.Map) => {
    setMap(mapInstance)
  }, [])

  let value = React.useMemo(
    () => ({
      map,
      handleMapLoad,
      setSearch,
      search,
    }),
    [map, handleMapLoad, search]
  )

  return <MapContext.Provider value={value} {...props} />
}

export function useGoogleMap() {
  const context = React.useContext(MapContext)
  if (!context) {
    throw new Error('useGoogleMap must be within a MapProvider')
  }

  return context
}

export default useGoogleMap
